"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('bson'),
  ObjectId = _require.ObjectID;
var tv4 = require('tv4');
var Helper = require('../../helper/helper');
var LaundryLocation = /*#__PURE__*/function () {
  function LaundryLocation(opt) {
    _classCallCheck(this, LaundryLocation);
    this._id = new ObjectId();
    this.barcode = null;
    this.campusCode = null;
    this.tenantCode = null;
    this.buildingName = null;
    this.roomNumber = null;
    this.buildingId = null;
    this.roomId = null;
    this.name = null;
    this.active = true;
    this.notes = '';
    if (opt) {
      this.fillObject(opt);
    }
  }
  _createClass(LaundryLocation, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.barcode = opt.barcode;
      this.campusCode = opt.campusCode;
      this.tenantCode = opt.tenantCode || Helper.campusCodeToTenantCode(opt.campusCode);
      this.buildingName = opt.buildingName || null;
      this.roomNumber = opt.roomNumber || null;
      this.buildingId = opt.buildingId || null;
      this.roomId = opt.roomId || null;
      this.name = opt.name || null;
      this.active = !!opt.active;
      this.notes = opt.notes || '';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, LaundryLocation.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'laundry.schema.json',
        title: 'laundry location Schema',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'object'
          },
          barcode: {
            type: ['string', 'null']
          },
          campusCode: {
            type: 'string'
          },
          tenantCode: {
            type: 'string'
          },
          buildingName: {
            type: ['string', 'null']
          },
          roomNumber: {
            type: ['string', 'null']
          },
          buildingId: {
            type: ['string', 'null']
          },
          roomId: {
            type: ['string', 'null']
          },
          name: {
            type: 'string'
          },
          active: {
            type: 'boolean'
          },
          notes: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return LaundryLocation;
}();
module.exports = LaundryLocation;